import { lazy } from 'react';


export default [
  { path: '/map?', element: lazy(() => import('containers/pages/Main')), external: false },
  { path: '/map/projects/:projectId?', element: lazy(() => import('containers/pages/Main')), external: false },
  { path: '/login', element: lazy(() => import('containers/pages/Login')), external: true },
  { path: '/reset-password', element: lazy(() => import('containers/pages/ResetPassword')), external: true },
  { path: '/company/*', element: lazy(() => import('containers/pages/Personal')), external: false },
  { path: '/admin/*', element: lazy(() => import('containers/pages/Personal')), external: false },
  { path: '/catalog/*', element: lazy(() => import('containers/pages/Personal')), external: false },
  { path: '/profile/*', element: lazy(() => import('containers/pages/Personal')), external: false },
  { path: '/preview/*', element: lazy(() => import('containers/pages/Preview')), external: false },
  { path: '/admin-preview/:projectId?', element: lazy(() => import('containers/pages/Preview/AdminPreview')), external: false },
  { path: '/registration/requests', element: lazy(() => import('containers/pages/Registration')), external: true },
  { path: '/registration/emailVerified', element: lazy(() => import('containers/pages/Registration/EmailVerified')), external: true },
  { path: '/personal/*', element: lazy(() => import('components/Redirect/Redirect')), external: false },
  { path: '/:projectId', element: lazy(() => import('components/Redirect/Redirect')), external: false },
];
